import { Trans, useLingui } from "@lingui/react/macro";

import VisionBg from "@/assets/images/vision-bg.jpeg";

import "@/styles/overlay.css";

import Logo from "@/assets/icons/logo.svg?react";
import img1 from "@/assets/images/exceptional-stays.png";

import MetaBox from "../shared/meta-box";

const VisionSection = () => {
  const { t } = useLingui();
  const metaData = [t`Comfort`, t`Security`, t`Effortless`, `International`];

  return (
    <section className="rounded-5xl flex w-full flex-col gap-5 overflow-hidden bg-center md:relative md:mb-[60px] md:flex-row md:gap-0">
      <p className="static start-[3.5%] bottom-[6%] mx-4 flex-col text-3xl leading-10 font-normal text-(--color-text-color-text-grey) sm:block md:absolute md:z-3 md:m-0 md:text-[3rem] md:leading-[86px] md:text-(--color-text-color-text-beige) lg:flex lg:text-[5rem]">
        <Trans>
          <span>What We </span>
          <strong className="font-semibold">Dream Of</strong>
        </Trans>
      </p>

      <div className="relative z-2 flex aspect-16/9 h-full w-full items-center justify-center overflow-hidden border-0 shadow-none">
        <img alt="Vision Background" src={VisionBg} className="h-full w-full object-cover" />
        {/* <div className="overlay_gradient absolute inset-0 hidden md:block" /> */}
      </div>

      <div className="static end-[2%] top-[4%] mb-12 w-full sm:z-2 md:absolute md:w-[26%] md:min-w-[370px]">
        <div className="mb-5 flex w-full flex-col gap-6 rounded-4xl bg-(--color-bg-color-bg-dark-beige) p-5 text-(--color-text-color-text-grey)">
          <div className="flex h-full grow justify-between p-0">
            <div className="gap-auto flex flex-col items-start justify-between">
              <Logo width={46} height={46} />
              <span className="max-w-[80%] text-2xl leading-[30px] font-semibold">
                <Trans>El Safwa’s Aim</Trans>
              </span>
            </div>
            <img alt="El Safwa’s Aim" src={img1} width={132} height={132} />
          </div>
          <p className="text-base leading-[26px] font-medium">
            <Trans>
              El Safwa continues to redefine the way people stay through thoughtfully designed
              serviced apartments, personalized hospitality, and a deep commitment to making people
              feel at home
            </Trans>
          </p>
        </div>
        <MetaBox metaData={metaData} />
      </div>
    </section>
  );
};

export default VisionSection;
